/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var HelpSearchResults = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,

		on: function(callback) {
			callback();
		},

		after: function() {
			this.findElements();
		},

		initSearch: function(searchContainer) {
			this.searchContainer = searchContainer;
		},

		searchConfigChanged: function(config) {
			var query = config.query;
			this.loadResults(query);
			this.loadSpellchecker(query);
		},

		loadResults: function(query) {
			var mod = this;
			var path = this.path.replace('.html/', '.ajax.html/') + query;
			$.ajax({
				url : path,
				timeout : 10000,
				success : function(data) {
					mod.$searchresult.html(data);
					var nextButton = mod.$searchresult.find('.nextsearch');
					var items = mod.$searchresult.find('.articleresultitem');
					SCS.portal.initPaging(nextButton, items);
				}
			});
		},

		loadSpellchecker: function(query) {
			var mod = this;
			var path = this.path.replace('.html/', '.spellchecker.html/') + query;
			$.ajax({
				url : path,
				timeout : 10000,
				success : function(data) {
					mod.$spellchecker.html(data);
				}
			});
		},

		findElements: function() {
			var path = this.$ctx.attr('data-path');
			if(path.indexOf('.html') === -1) {
				path = path + '.html';
			}
			// Append slash after .html (the search term comes next)
			this.path = path.replace(/(\.html)\/?.*?$/, '$1/');
			this.$searchresult = this.$ctx.find('.searchresult');
			this.$spellchecker = this.$ctx.find('.spellchecker');
		}

	});

	Module.HelpSearchResults = HelpSearchResults;

})(window.Tc.Module, window.Tc.$, window.SCS = window.SCS || {});

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/modules/Tc.Module.HelpSearchResults.js
// module id = 352
// module chunks = 0